import axios from 'axios';

export const getAxiosWithAuth = () => {
  const axiosWithAuth = axios.create({
    headers: {
      Authorization: localStorage.getItem('feathers-jwt'),
    },
  });
  return axiosWithAuth;
};

const axiosWithAuth = getAxiosWithAuth();

const interval = setInterval(() => {
  const token = localStorage.getItem('feathers-jwt');
  if (token) {
    axiosWithAuth.defaults.headers.Authorization = token;
    clearInterval(interval);
  }
  console.warn('token not ready');
}, 1000);

export default axiosWithAuth;
